import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { generatePriceEstimation } from "../utils/aiPriceUtils";

// Fake data mẫu để test
const FAKE_ANALYSIS_RESULTS = {
  apartment: {
    estimatedPrice: "3.2 tỷ VNĐ",
    pricePerM2: "65 triệu VNĐ/m²",
    marketTrend: "Tăng",
    confidence: "Cao - Dựa trên phân tích 150+ BĐS tương tự",
    similarProperties: [
      {
        address: "Vinhomes Central Park, Q. Bình Thạnh",
        area: "75 m²",
        price: "3.1 tỷ VNĐ",
      },
      {
        address: "The Manor HCM, Q. Bình Thạnh",
        area: "80 m²",
        price: "3.4 tỷ VNĐ",
      },
      {
        address: "Vista Verde, Q. 2",
        area: "72 m²",
        price: "3.0 tỷ VNĐ",
      },
    ],
    marketInsights: [
      "Thị trường căn hộ cao cấp Q. Bình Thạnh đang tăng 8-12% YoY",
      "Nhu cầu cao do vị trí gần trung tâm và hạ tầng hoàn thiện",
      "Dự báo giá sẽ tiếp tục tăng 5-8% trong 6 tháng tới",
      "Thanh khoản tốt, thời gian bán trung bình 2-3 tháng",
      "Khuyến nghị: Thời điểm tốt để bán",
    ],
    manusAnalysis: `
🏠 **PHÂN TÍCH ĐỊNH GIÁ CHI TIẾT**

**Thông tin cơ bản:**
- Loại BĐS: Căn hộ chung cư
- Diện tích: 78m² 
- Vị trí: Quận Bình Thạnh, TP.HCM
- Hướng: Đông Nam (tốt)

**Định giá thị trường:**
- Giá ước tính: **3.2 tỷ VNĐ**
- Đơn giá: **65 triệu/m²**
- Biên độ dao động: 3.0 - 3.4 tỷ VNĐ

**Phân tích thị trường:**
- Xu hướng: **TĂNG** 📈
- Mức độ thanh khoản: **CAO** 
- Thời gian bán dự kiến: 2-3 tháng

**Các yếu tố tích cực:**
✅ Vị trí đắc địa gần trung tâm
✅ Hạ tầng giao thông thuận lợi  
✅ Pháp lý rõ ràng
✅ Cộng đồng dân cư chất lượng cao

**Khuyến nghị:**
🎯 **Thời điểm TỐT để bán** - Thị trường đang có xu hướng tích cực
    `,
  },
  private_house: {
    estimatedPrice: "8.5 tỷ VNĐ",
    pricePerM2: "170 triệu VNĐ/m² đất",
    marketTrend: "Ổn định",
    confidence: "Cao - Dựa trên phân tích 80+ nhà riêng khu vực",
    similarProperties: [
      {
        address: "Đường Võ Văn Tần, Q. 3",
        area: "45 m² đất, 120 m² XD",
        price: "8.2 tỷ VNĐ",
      },
      {
        address: "Đường Trần Quang Khải, Q. 1",
        area: "48 m² đất, 140 m² XD",
        price: "9.1 tỷ VNĐ",
      },
      {
        address: "Đường Nguyễn Đình Chiểu, Q. 3",
        area: "52 m² đất, 110 m² XD",
        price: "8.8 tỷ VNĐ",
      },
    ],
    marketInsights: [
      "Thị trường nhà riêng trung tâm TP.HCM ổn định",
      "Nguồn cung hạn chế do quy hoạch đô thị",
      "Giá trị tăng ổn định 3-5% mỗi năm",
      "Thanh khoản trung bình, thời gian bán 4-6 tháng",
      "Khuyến nghị: Giữ đầu tư dài hạn hoặc bán nếu cần thanh khoản",
    ],
    manusAnalysis: `
🏠 **PHÂN TÍCH ĐỊNH GIÁ NHÀ RIÊNG**

**Thông tin cơ bản:**
- Loại BĐS: Nhà riêng/Nhà phố
- Diện tích đất: 50m²
- Diện tích xây dựng: 130m²
- Vị trí: Quận 3, TP.HCM

**Định giá thị trường:**
- Giá ước tính: **8.5 tỷ VNĐ**
- Đơn giá đất: **170 triệu/m²**
- Biên độ dao động: 8.0 - 9.0 tỷ VNĐ

**Phân tích thị trường:**
- Xu hướng: **ỔN ĐỊNH** 📊
- Mức độ thanh khoản: **TRUNG BÌNH**
- Thời gian bán dự kiến: 4-6 tháng

**Các yếu tố tích cực:**
✅ Vị trí trung tâm thành phố
✅ Hẻm xe ô tô, giao thông thuận lợi
✅ Khu vực dân cư an ninh tốt
✅ Gần trường học, bệnh viện

**Khuyến nghị:**
🎯 **Thời điểm TƯƠNG ĐỐI TỐT** - Thị trường ổn định, phù hợp đầu tư dài hạn
    `,
  },
  land: {
    estimatedPrice: "12.5 tỷ VNĐ",
    pricePerM2: "125 triệu VNĐ/m²",
    marketTrend: "Tăng mạnh",
    confidence: "Trung bình - Cần khảo sát thực địa chi tiết",
    similarProperties: [
      {
        address: "Đường Nguyễn Văn Linh, Q. 7",
        area: "100 m²",
        price: "12.0 tỷ VNĐ",
      },
      {
        address: "Đường Huỳnh Tấn Phát, Q. 7",
        area: "120 m²",
        price: "14.5 tỷ VNĐ",
      },
    ],
    marketInsights: [
      "Thị trường đất nền Q. 7 tăng mạnh 15-20% YoY",
      "Hưởng lợi từ hạ tầng giao thông mới",
      "Nguồn cung khan hiếm do quy hoạch chặt chẽ",
      "Thanh khoản cao, thời gian bán 1-2 tháng",
      "Khuyến nghị: Thời điểm rất tốt để bán",
    ],
    manusAnalysis: `
🏠 **PHÂN TÍCH ĐỊNH GIÁ ĐẤT NỀN**

**Thông tin cơ bản:**
- Loại BĐS: Đất nền thổ cư
- Diện tích: 100m²
- Vị trí: Quận 7, TP.HCM
- Mặt tiền: 5m

**Định giá thị trường:**
- Giá ước tính: **12.5 tỷ VNĐ**
- Đơn giá: **125 triệu/m²**
- Biên độ dao động: 11.5 - 13.5 tỷ VNĐ

**Phân tích thị trường:**
- Xu hướng: **TĂNG MẠNH** 📈📈
- Mức độ thanh khoản: **RẤT CAO**
- Thời gian bán dự kiến: 1-2 tháng

**Khuyến nghị:**
🎯 **Thời điểm RẤT TỐT để bán** - Thị trường đang rất sôi động
    `,
  },
};

const FAKE_UPLOADED_FILES = [
  {
    id: "file1",
    name: "market_analysis_report.pdf",
    type: "PDF",
    size: "2.4 MB",
    url: "#",
  },
  {
    id: "file2",
    name: "property_comparison.xlsx",
    type: "Excel",
    size: "1.8 MB",
    url: "#",
  },
  {
    id: "file3",
    name: "location_insights.docx",
    type: "Word",
    size: "956 KB",
    url: "#",
  },
];

export const useTestMode = (formData) => {
  const [isTestMode, setIsTestMode] = useState(false);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [analysisProgress, setAnalysisProgress] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [manusResponse, setManusResponse] = useState(null);

  // Toggle test mode
  const toggleTestMode = useCallback(() => {
    setIsTestMode((prev) => !prev);
    if (!isTestMode) {
      toast.info("🧪 Đã bật chế độ test - Sử dụng data fake để test nhanh", {
        position: "top-right",
        autoClose: 3000,
      });
    } else {
      toast.info("🔄 Đã tắt chế độ test - Sử dụng API thật", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [isTestMode]);

  // Simulate analysis progress
  const simulateProgress = useCallback((onComplete) => {
    const progressSteps = [
      { text: "🔄 Đang khởi tạo phân tích...", delay: 500 },
      { text: "📊 Đang thu thập dữ liệu thị trường...", delay: 800 },
      { text: "🏠 Đang so sánh với BĐS tương tự...", delay: 1000 },
      { text: "📈 Đang phân tích xu hướng giá...", delay: 700 },
      { text: "🎯 Đang tính toán định giá cuối cùng...", delay: 600 },
      { text: "✅ Hoàn thành phân tích!", delay: 300 },
    ];

    let currentStep = 0;

    const runStep = () => {
      if (currentStep < progressSteps.length) {
        setAnalysisProgress(progressSteps[currentStep].text);
        setTimeout(() => {
          currentStep++;
          runStep();
        }, progressSteps[currentStep].delay);
      } else {
        onComplete();
      }
    };

    runStep();
  }, []);

  // Handle test analyze price
  const handleTestAnalyzePrice = useCallback(
    async (formValidation, onPriceResult) => {
      if (!formValidation.isValid) {
        const errorMessage = formValidation.errors.slice(0, 3).join(", ");
        toast.error(
          `${errorMessage}${formValidation.errors.length > 3 ? "..." : ""}`,
          {
            position: "top-right",
            autoClose: 5000,
            icon: "⚠️",
          }
        );
        return;
      }

      setIsAnalyzing(true);
      setAnalysisProgress("Đang khởi tạo phân tích...");
      setUploadedFiles([]);

      // Simulate analysis with progress
      simulateProgress(() => {
        setTimeout(() => {
          // Get fake result based on property type
          const propertyType = formData.propertyType || "apartment";
          let fakeResult =
            FAKE_ANALYSIS_RESULTS[propertyType] ||
            FAKE_ANALYSIS_RESULTS.apartment;

          // Customize result based on form data
          if (formData.area) {
            const basePrice =
              propertyType === "apartment"
                ? 65
                : propertyType === "private_house"
                ? 170
                : 125;
            const estimatedTotal = (formData.area * basePrice).toLocaleString(
              "vi-VN"
            );
            fakeResult = {
              ...fakeResult,
              estimatedPrice: `${estimatedTotal} triệu VNĐ`,
              pricePerM2: `${basePrice} triệu VNĐ/m²`,
            };
          }

          // Set fake uploaded files
          setUploadedFiles(FAKE_UPLOADED_FILES);

          // Set fake manus response
          setManusResponse({
            chat_messages: [
              {
                manus_message: fakeResult.manusAnalysis,
              },
            ],
          });

          onPriceResult(fakeResult);
          setIsAnalyzing(false);

          toast.success("🧪 Phân tích test hoàn thành với data fake!", {
            position: "top-right",
            autoClose: 3000,
            icon: "✅",
          });
        }, 300);
      });
    },
    [formData, simulateProgress]
  );

  // Reset analysis state
  const resetTestAnalysis = useCallback(() => {
    setManusResponse(null);
    setAnalysisProgress("");
    setUploadedFiles([]);
  }, []);

  // Cleanup function (no-op for test mode)
  const cleanupWebSocket = useCallback(() => {
    // No cleanup needed for test mode
  }, []);

  return {
    isTestMode,
    toggleTestMode,
    isAnalyzing,
    analysisProgress,
    manusResponse,
    uploadedFiles,
    handleAnalyzePrice: handleTestAnalyzePrice,
    resetAnalysis: resetTestAnalysis,
    cleanupWebSocket,
  };
};
